export const environment = {
  production: false,
  apiUrl: 'https://www.armoireconnectee.janneau.com/api'
};

